export default "__VITE_ASSET__D3Q3JYet__"